/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as VerifiedRouteImport } from './routes/verified'
import { Route as PrivateHomeRouteImport } from './routes/_private/_home'
import { Route as PrivateSignupRouteImport } from './routes/_private/signup'
import { Route as PrivateSubscriptionPendingRouteImport } from './routes/_private/subscription-pending'
import { Route as PrivateHomeIndexRouteImport } from './routes/_private/_home/index'
import { Route as PrivateHomeComponentsRouteImport } from './routes/_private/_home/components'
import { Route as PrivateHomePricingRouteImport } from './routes/_private/_home/pricing'
import { Route as PrivateHomeSceneRouteImport } from './routes/_private/_home/scene'
import { Route as PrivateHomeSettingsRouteRouteImport } from './routes/_private/_home/settings/route'
import { Route as PrivateHomeTeamRouteImport } from './routes/_private/_home/team'
import { Route as PrivateHomeCourseExportsIndexRouteImport } from './routes/_private/_home/course-exports/index'
import { Route as PrivateHomeCourseExportsCourse_version_guidRouteImport } from './routes/_private/_home/course-exports/$course_version_guid'
import { Route as PrivateHomeMediaChar123FolderIdChar125RouteImport } from './routes/_private/_home/media.{-$folderId}'
import { Route as PrivateHomeProjectIndexRouteImport } from './routes/_private/_home/project/index'
import { Route as PrivateHomeSettingsIndexRouteImport } from './routes/_private/_home/settings/index'
import { Route as PrivateHomeSettingsBillingRouteImport } from './routes/_private/_home/settings/billing'
import { Route as PrivateHomeSettingsGeneralRouteImport } from './routes/_private/_home/settings/general'
import { Route as PrivateHomeProjectProject_idSettingsRouteRouteImport } from './routes/_private/_home/project/$project_id/settings/route'
import { Route as PrivateHomeProjectProject_idSettingsIndexRouteImport } from './routes/_private/_home/project/$project_id/settings/index'
import { Route as PrivateHomeProjectProject_idSettingsBrandingRouteImport } from './routes/_private/_home/project/$project_id/settings/branding'
import { Route as PrivateHomeProjectProject_idSettingsCourseExportsRouteImport } from './routes/_private/_home/project/$project_id/settings/course-exports'
import { Route as PrivateHomeProjectProject_idSettingsExportRouteImport } from './routes/_private/_home/project/$project_id/settings/export'
import { Route as PrivateHomeProjectProject_idSettingsSharingRouteImport } from './routes/_private/_home/project/$project_id/settings/sharing'
import { Route as PrivateHomeProjectProject_idSettingsTrackingRouteImport } from './routes/_private/_home/project/$project_id/settings/tracking'
import { Route as PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRouteImport } from './routes/_private/course-exports.$course_version_guid.versions.$version_guid.preview'

const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifiedRoute = VerifiedRouteImport.update({
  id: '/verified',
  path: '/verified',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateHomeRoute = PrivateHomeRouteImport.update({
  id: '/_home',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSignupRoute = PrivateSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSubscriptionPendingRoute =
  PrivateSubscriptionPendingRouteImport.update({
    id: '/subscription-pending',
    path: '/subscription-pending',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateHomeIndexRoute = PrivateHomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateHomeRoute,
} as any)
const PrivateHomeComponentsRoute = PrivateHomeComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => PrivateHomeRoute,
} as any)
const PrivateHomePricingRoute = PrivateHomePricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => PrivateHomeRoute,
} as any)
const PrivateHomeSceneRoute = PrivateHomeSceneRouteImport.update({
  id: '/scene',
  path: '/scene',
  getParentRoute: () => PrivateHomeRoute,
} as any)
const PrivateHomeSettingsRouteRoute =
  PrivateHomeSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => PrivateHomeRoute,
  } as any)
const PrivateHomeTeamRoute = PrivateHomeTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => PrivateHomeRoute,
} as any)
const PrivateHomeCourseExportsIndexRoute =
  PrivateHomeCourseExportsIndexRouteImport.update({
    id: '/course-exports/',
    path: '/course-exports/',
    getParentRoute: () => PrivateHomeRoute,
  } as any)
const PrivateHomeCourseExportsCourse_version_guidRoute =
  PrivateHomeCourseExportsCourse_version_guidRouteImport.update({
    id: '/course-exports/$course_version_guid',
    path: '/course-exports/$course_version_guid',
    getParentRoute: () => PrivateHomeRoute,
  } as any)
const PrivateHomeMediaChar123FolderIdChar125Route =
  PrivateHomeMediaChar123FolderIdChar125RouteImport.update({
    id: '/media/{-$folderId}',
    path: '/media/{-$folderId}',
    getParentRoute: () => PrivateHomeRoute,
  } as any)
const PrivateHomeProjectIndexRoute = PrivateHomeProjectIndexRouteImport.update({
  id: '/project/',
  path: '/project/',
  getParentRoute: () => PrivateHomeRoute,
} as any)
const PrivateHomeSettingsIndexRoute =
  PrivateHomeSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateHomeSettingsRouteRoute,
  } as any)
const PrivateHomeSettingsBillingRoute =
  PrivateHomeSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => PrivateHomeSettingsRouteRoute,
  } as any)
const PrivateHomeSettingsGeneralRoute =
  PrivateHomeSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => PrivateHomeSettingsRouteRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsRouteRoute =
  PrivateHomeProjectProject_idSettingsRouteRouteImport.update({
    id: '/project/$project_id/settings',
    path: '/project/$project_id/settings',
    getParentRoute: () => PrivateHomeRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsIndexRoute =
  PrivateHomeProjectProject_idSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateHomeProjectProject_idSettingsRouteRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsBrandingRoute =
  PrivateHomeProjectProject_idSettingsBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => PrivateHomeProjectProject_idSettingsRouteRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsCourseExportsRoute =
  PrivateHomeProjectProject_idSettingsCourseExportsRouteImport.update({
    id: '/course-exports',
    path: '/course-exports',
    getParentRoute: () => PrivateHomeProjectProject_idSettingsRouteRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsExportRoute =
  PrivateHomeProjectProject_idSettingsExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => PrivateHomeProjectProject_idSettingsRouteRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsSharingRoute =
  PrivateHomeProjectProject_idSettingsSharingRouteImport.update({
    id: '/sharing',
    path: '/sharing',
    getParentRoute: () => PrivateHomeProjectProject_idSettingsRouteRoute,
  } as any)
const PrivateHomeProjectProject_idSettingsTrackingRoute =
  PrivateHomeProjectProject_idSettingsTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => PrivateHomeProjectProject_idSettingsRouteRoute,
  } as any)
const PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute =
  PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRouteImport.update(
    {
      id: '/course-exports/$course_version_guid/versions/$version_guid/preview',
      path: '/course-exports/$course_version_guid/versions/$version_guid/preview',
      getParentRoute: () => PrivateRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof PrivateHomeIndexRoute
  '/verified': typeof VerifiedRoute
  '/signup': typeof PrivateSignupRoute
  '/subscription-pending': typeof PrivateSubscriptionPendingRoute
  '/settings': typeof PrivateHomeSettingsRouteRouteWithChildren
  '/components': typeof PrivateHomeComponentsRoute
  '/pricing': typeof PrivateHomePricingRoute
  '/scene': typeof PrivateHomeSceneRoute
  '/team': typeof PrivateHomeTeamRoute
  '/course-exports/$course_version_guid': typeof PrivateHomeCourseExportsCourse_version_guidRoute
  '/media/{-$folderId}': typeof PrivateHomeMediaChar123FolderIdChar125Route
  '/settings/billing': typeof PrivateHomeSettingsBillingRoute
  '/settings/general': typeof PrivateHomeSettingsGeneralRoute
  '/course-exports/': typeof PrivateHomeCourseExportsIndexRoute
  '/project/': typeof PrivateHomeProjectIndexRoute
  '/settings/': typeof PrivateHomeSettingsIndexRoute
  '/project/$project_id/settings': typeof PrivateHomeProjectProject_idSettingsRouteRouteWithChildren
  '/project/$project_id/settings/branding': typeof PrivateHomeProjectProject_idSettingsBrandingRoute
  '/project/$project_id/settings/course-exports': typeof PrivateHomeProjectProject_idSettingsCourseExportsRoute
  '/project/$project_id/settings/export': typeof PrivateHomeProjectProject_idSettingsExportRoute
  '/project/$project_id/settings/sharing': typeof PrivateHomeProjectProject_idSettingsSharingRoute
  '/project/$project_id/settings/tracking': typeof PrivateHomeProjectProject_idSettingsTrackingRoute
  '/course-exports/$course_version_guid/versions/$version_guid/preview': typeof PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute
  '/project/$project_id/settings/': typeof PrivateHomeProjectProject_idSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PrivateHomeIndexRoute
  '/verified': typeof VerifiedRoute
  '/signup': typeof PrivateSignupRoute
  '/subscription-pending': typeof PrivateSubscriptionPendingRoute
  '/components': typeof PrivateHomeComponentsRoute
  '/pricing': typeof PrivateHomePricingRoute
  '/scene': typeof PrivateHomeSceneRoute
  '/team': typeof PrivateHomeTeamRoute
  '/course-exports/$course_version_guid': typeof PrivateHomeCourseExportsCourse_version_guidRoute
  '/media/{-$folderId}': typeof PrivateHomeMediaChar123FolderIdChar125Route
  '/settings/billing': typeof PrivateHomeSettingsBillingRoute
  '/settings/general': typeof PrivateHomeSettingsGeneralRoute
  '/course-exports': typeof PrivateHomeCourseExportsIndexRoute
  '/project': typeof PrivateHomeProjectIndexRoute
  '/settings': typeof PrivateHomeSettingsIndexRoute
  '/project/$project_id/settings/branding': typeof PrivateHomeProjectProject_idSettingsBrandingRoute
  '/project/$project_id/settings/course-exports': typeof PrivateHomeProjectProject_idSettingsCourseExportsRoute
  '/project/$project_id/settings/export': typeof PrivateHomeProjectProject_idSettingsExportRoute
  '/project/$project_id/settings/sharing': typeof PrivateHomeProjectProject_idSettingsSharingRoute
  '/project/$project_id/settings/tracking': typeof PrivateHomeProjectProject_idSettingsTrackingRoute
  '/course-exports/$course_version_guid/versions/$version_guid/preview': typeof PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute
  '/project/$project_id/settings': typeof PrivateHomeProjectProject_idSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_private': typeof PrivateRouteWithChildren
  '/verified': typeof VerifiedRoute
  '/_private/_home': typeof PrivateHomeRouteWithChildren
  '/_private/signup': typeof PrivateSignupRoute
  '/_private/subscription-pending': typeof PrivateSubscriptionPendingRoute
  '/_private/_home/settings': typeof PrivateHomeSettingsRouteRouteWithChildren
  '/_private/_home/components': typeof PrivateHomeComponentsRoute
  '/_private/_home/pricing': typeof PrivateHomePricingRoute
  '/_private/_home/scene': typeof PrivateHomeSceneRoute
  '/_private/_home/team': typeof PrivateHomeTeamRoute
  '/_private/_home/': typeof PrivateHomeIndexRoute
  '/_private/_home/course-exports/$course_version_guid': typeof PrivateHomeCourseExportsCourse_version_guidRoute
  '/_private/_home/media/{-$folderId}': typeof PrivateHomeMediaChar123FolderIdChar125Route
  '/_private/_home/settings/billing': typeof PrivateHomeSettingsBillingRoute
  '/_private/_home/settings/general': typeof PrivateHomeSettingsGeneralRoute
  '/_private/_home/course-exports/': typeof PrivateHomeCourseExportsIndexRoute
  '/_private/_home/project/': typeof PrivateHomeProjectIndexRoute
  '/_private/_home/settings/': typeof PrivateHomeSettingsIndexRoute
  '/_private/_home/project/$project_id/settings': typeof PrivateHomeProjectProject_idSettingsRouteRouteWithChildren
  '/_private/_home/project/$project_id/settings/branding': typeof PrivateHomeProjectProject_idSettingsBrandingRoute
  '/_private/_home/project/$project_id/settings/course-exports': typeof PrivateHomeProjectProject_idSettingsCourseExportsRoute
  '/_private/_home/project/$project_id/settings/export': typeof PrivateHomeProjectProject_idSettingsExportRoute
  '/_private/_home/project/$project_id/settings/sharing': typeof PrivateHomeProjectProject_idSettingsSharingRoute
  '/_private/_home/project/$project_id/settings/tracking': typeof PrivateHomeProjectProject_idSettingsTrackingRoute
  '/_private/course-exports/$course_version_guid/versions/$version_guid/preview': typeof PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute
  '/_private/_home/project/$project_id/settings/': typeof PrivateHomeProjectProject_idSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/verified'
    | '/signup'
    | '/subscription-pending'
    | '/settings'
    | '/components'
    | '/pricing'
    | '/scene'
    | '/team'
    | '/course-exports/$course_version_guid'
    | '/media/{-$folderId}'
    | '/settings/billing'
    | '/settings/general'
    | '/course-exports/'
    | '/project/'
    | '/settings/'
    | '/project/$project_id/settings'
    | '/project/$project_id/settings/branding'
    | '/project/$project_id/settings/course-exports'
    | '/project/$project_id/settings/export'
    | '/project/$project_id/settings/sharing'
    | '/project/$project_id/settings/tracking'
    | '/course-exports/$course_version_guid/versions/$version_guid/preview'
    | '/project/$project_id/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/verified'
    | '/signup'
    | '/subscription-pending'
    | '/components'
    | '/pricing'
    | '/scene'
    | '/team'
    | '/course-exports/$course_version_guid'
    | '/media/{-$folderId}'
    | '/settings/billing'
    | '/settings/general'
    | '/course-exports'
    | '/project'
    | '/settings'
    | '/project/$project_id/settings/branding'
    | '/project/$project_id/settings/course-exports'
    | '/project/$project_id/settings/export'
    | '/project/$project_id/settings/sharing'
    | '/project/$project_id/settings/tracking'
    | '/course-exports/$course_version_guid/versions/$version_guid/preview'
    | '/project/$project_id/settings'
  id:
    | '__root__'
    | '/_private'
    | '/verified'
    | '/_private/_home'
    | '/_private/signup'
    | '/_private/subscription-pending'
    | '/_private/_home/settings'
    | '/_private/_home/components'
    | '/_private/_home/pricing'
    | '/_private/_home/scene'
    | '/_private/_home/team'
    | '/_private/_home/'
    | '/_private/_home/course-exports/$course_version_guid'
    | '/_private/_home/media/{-$folderId}'
    | '/_private/_home/settings/billing'
    | '/_private/_home/settings/general'
    | '/_private/_home/course-exports/'
    | '/_private/_home/project/'
    | '/_private/_home/settings/'
    | '/_private/_home/project/$project_id/settings'
    | '/_private/_home/project/$project_id/settings/branding'
    | '/_private/_home/project/$project_id/settings/course-exports'
    | '/_private/_home/project/$project_id/settings/export'
    | '/_private/_home/project/$project_id/settings/sharing'
    | '/_private/_home/project/$project_id/settings/tracking'
    | '/_private/course-exports/$course_version_guid/versions/$version_guid/preview'
    | '/_private/_home/project/$project_id/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PrivateRoute: typeof PrivateRouteWithChildren
  VerifiedRoute: typeof VerifiedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verified': {
      id: '/verified'
      path: '/verified'
      fullPath: '/verified'
      preLoaderRoute: typeof VerifiedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/_home': {
      id: '/_private/_home'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateHomeRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/signup': {
      id: '/_private/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PrivateSignupRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/subscription-pending': {
      id: '/_private/subscription-pending'
      path: '/subscription-pending'
      fullPath: '/subscription-pending'
      preLoaderRoute: typeof PrivateSubscriptionPendingRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/_home/': {
      id: '/_private/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivateHomeIndexRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/components': {
      id: '/_private/_home/components'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof PrivateHomeComponentsRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/pricing': {
      id: '/_private/_home/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PrivateHomePricingRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/scene': {
      id: '/_private/_home/scene'
      path: '/scene'
      fullPath: '/scene'
      preLoaderRoute: typeof PrivateHomeSceneRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/settings': {
      id: '/_private/_home/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateHomeSettingsRouteRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/team': {
      id: '/_private/_home/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof PrivateHomeTeamRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/course-exports/': {
      id: '/_private/_home/course-exports/'
      path: '/course-exports'
      fullPath: '/course-exports/'
      preLoaderRoute: typeof PrivateHomeCourseExportsIndexRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/course-exports/$course_version_guid': {
      id: '/_private/_home/course-exports/$course_version_guid'
      path: '/course-exports/$course_version_guid'
      fullPath: '/course-exports/$course_version_guid'
      preLoaderRoute: typeof PrivateHomeCourseExportsCourse_version_guidRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/media/{-$folderId}': {
      id: '/_private/_home/media/{-$folderId}'
      path: '/media/{-$folderId}'
      fullPath: '/media/{-$folderId}'
      preLoaderRoute: typeof PrivateHomeMediaChar123FolderIdChar125RouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/project/': {
      id: '/_private/_home/project/'
      path: '/project'
      fullPath: '/project/'
      preLoaderRoute: typeof PrivateHomeProjectIndexRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/settings/': {
      id: '/_private/_home/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof PrivateHomeSettingsIndexRouteImport
      parentRoute: typeof PrivateHomeSettingsRouteRoute
    }
    '/_private/_home/settings/billing': {
      id: '/_private/_home/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof PrivateHomeSettingsBillingRouteImport
      parentRoute: typeof PrivateHomeSettingsRouteRoute
    }
    '/_private/_home/settings/general': {
      id: '/_private/_home/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof PrivateHomeSettingsGeneralRouteImport
      parentRoute: typeof PrivateHomeSettingsRouteRoute
    }
    '/_private/_home/project/$project_id/settings': {
      id: '/_private/_home/project/$project_id/settings'
      path: '/project/$project_id/settings'
      fullPath: '/project/$project_id/settings'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsRouteRouteImport
      parentRoute: typeof PrivateHomeRoute
    }
    '/_private/_home/project/$project_id/settings/': {
      id: '/_private/_home/project/$project_id/settings/'
      path: '/'
      fullPath: '/project/$project_id/settings/'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsIndexRouteImport
      parentRoute: typeof PrivateHomeProjectProject_idSettingsRouteRoute
    }
    '/_private/_home/project/$project_id/settings/branding': {
      id: '/_private/_home/project/$project_id/settings/branding'
      path: '/branding'
      fullPath: '/project/$project_id/settings/branding'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsBrandingRouteImport
      parentRoute: typeof PrivateHomeProjectProject_idSettingsRouteRoute
    }
    '/_private/_home/project/$project_id/settings/course-exports': {
      id: '/_private/_home/project/$project_id/settings/course-exports'
      path: '/course-exports'
      fullPath: '/project/$project_id/settings/course-exports'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsCourseExportsRouteImport
      parentRoute: typeof PrivateHomeProjectProject_idSettingsRouteRoute
    }
    '/_private/_home/project/$project_id/settings/export': {
      id: '/_private/_home/project/$project_id/settings/export'
      path: '/export'
      fullPath: '/project/$project_id/settings/export'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsExportRouteImport
      parentRoute: typeof PrivateHomeProjectProject_idSettingsRouteRoute
    }
    '/_private/_home/project/$project_id/settings/sharing': {
      id: '/_private/_home/project/$project_id/settings/sharing'
      path: '/sharing'
      fullPath: '/project/$project_id/settings/sharing'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsSharingRouteImport
      parentRoute: typeof PrivateHomeProjectProject_idSettingsRouteRoute
    }
    '/_private/_home/project/$project_id/settings/tracking': {
      id: '/_private/_home/project/$project_id/settings/tracking'
      path: '/tracking'
      fullPath: '/project/$project_id/settings/tracking'
      preLoaderRoute: typeof PrivateHomeProjectProject_idSettingsTrackingRouteImport
      parentRoute: typeof PrivateHomeProjectProject_idSettingsRouteRoute
    }
    '/_private/course-exports/$course_version_guid/versions/$version_guid/preview': {
      id: '/_private/course-exports/$course_version_guid/versions/$version_guid/preview'
      path: '/course-exports/$course_version_guid/versions/$version_guid/preview'
      fullPath: '/course-exports/$course_version_guid/versions/$version_guid/preview'
      preLoaderRoute: typeof PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRouteImport
      parentRoute: typeof PrivateRoute
    }
  }
}

interface PrivateHomeSettingsRouteRouteChildren {
  PrivateHomeSettingsBillingRoute: typeof PrivateHomeSettingsBillingRoute
  PrivateHomeSettingsGeneralRoute: typeof PrivateHomeSettingsGeneralRoute
  PrivateHomeSettingsIndexRoute: typeof PrivateHomeSettingsIndexRoute
}

const PrivateHomeSettingsRouteRouteChildren: PrivateHomeSettingsRouteRouteChildren =
  {
    PrivateHomeSettingsBillingRoute: PrivateHomeSettingsBillingRoute,
    PrivateHomeSettingsGeneralRoute: PrivateHomeSettingsGeneralRoute,
    PrivateHomeSettingsIndexRoute: PrivateHomeSettingsIndexRoute,
  }

const PrivateHomeSettingsRouteRouteWithChildren =
  PrivateHomeSettingsRouteRoute._addFileChildren(
    PrivateHomeSettingsRouteRouteChildren,
  )

interface PrivateHomeProjectProject_idSettingsRouteRouteChildren {
  PrivateHomeProjectProject_idSettingsBrandingRoute: typeof PrivateHomeProjectProject_idSettingsBrandingRoute
  PrivateHomeProjectProject_idSettingsCourseExportsRoute: typeof PrivateHomeProjectProject_idSettingsCourseExportsRoute
  PrivateHomeProjectProject_idSettingsExportRoute: typeof PrivateHomeProjectProject_idSettingsExportRoute
  PrivateHomeProjectProject_idSettingsSharingRoute: typeof PrivateHomeProjectProject_idSettingsSharingRoute
  PrivateHomeProjectProject_idSettingsTrackingRoute: typeof PrivateHomeProjectProject_idSettingsTrackingRoute
  PrivateHomeProjectProject_idSettingsIndexRoute: typeof PrivateHomeProjectProject_idSettingsIndexRoute
}

const PrivateHomeProjectProject_idSettingsRouteRouteChildren: PrivateHomeProjectProject_idSettingsRouteRouteChildren =
  {
    PrivateHomeProjectProject_idSettingsBrandingRoute:
      PrivateHomeProjectProject_idSettingsBrandingRoute,
    PrivateHomeProjectProject_idSettingsCourseExportsRoute:
      PrivateHomeProjectProject_idSettingsCourseExportsRoute,
    PrivateHomeProjectProject_idSettingsExportRoute:
      PrivateHomeProjectProject_idSettingsExportRoute,
    PrivateHomeProjectProject_idSettingsSharingRoute:
      PrivateHomeProjectProject_idSettingsSharingRoute,
    PrivateHomeProjectProject_idSettingsTrackingRoute:
      PrivateHomeProjectProject_idSettingsTrackingRoute,
    PrivateHomeProjectProject_idSettingsIndexRoute:
      PrivateHomeProjectProject_idSettingsIndexRoute,
  }

const PrivateHomeProjectProject_idSettingsRouteRouteWithChildren =
  PrivateHomeProjectProject_idSettingsRouteRoute._addFileChildren(
    PrivateHomeProjectProject_idSettingsRouteRouteChildren,
  )

interface PrivateHomeRouteChildren {
  PrivateHomeSettingsRouteRoute: typeof PrivateHomeSettingsRouteRouteWithChildren
  PrivateHomeComponentsRoute: typeof PrivateHomeComponentsRoute
  PrivateHomePricingRoute: typeof PrivateHomePricingRoute
  PrivateHomeSceneRoute: typeof PrivateHomeSceneRoute
  PrivateHomeTeamRoute: typeof PrivateHomeTeamRoute
  PrivateHomeIndexRoute: typeof PrivateHomeIndexRoute
  PrivateHomeCourseExportsCourse_version_guidRoute: typeof PrivateHomeCourseExportsCourse_version_guidRoute
  PrivateHomeMediaChar123FolderIdChar125Route: typeof PrivateHomeMediaChar123FolderIdChar125Route
  PrivateHomeCourseExportsIndexRoute: typeof PrivateHomeCourseExportsIndexRoute
  PrivateHomeProjectIndexRoute: typeof PrivateHomeProjectIndexRoute
  PrivateHomeProjectProject_idSettingsRouteRoute: typeof PrivateHomeProjectProject_idSettingsRouteRouteWithChildren
}

const PrivateHomeRouteChildren: PrivateHomeRouteChildren = {
  PrivateHomeSettingsRouteRoute: PrivateHomeSettingsRouteRouteWithChildren,
  PrivateHomeComponentsRoute: PrivateHomeComponentsRoute,
  PrivateHomePricingRoute: PrivateHomePricingRoute,
  PrivateHomeSceneRoute: PrivateHomeSceneRoute,
  PrivateHomeTeamRoute: PrivateHomeTeamRoute,
  PrivateHomeIndexRoute: PrivateHomeIndexRoute,
  PrivateHomeCourseExportsCourse_version_guidRoute:
    PrivateHomeCourseExportsCourse_version_guidRoute,
  PrivateHomeMediaChar123FolderIdChar125Route:
    PrivateHomeMediaChar123FolderIdChar125Route,
  PrivateHomeCourseExportsIndexRoute: PrivateHomeCourseExportsIndexRoute,
  PrivateHomeProjectIndexRoute: PrivateHomeProjectIndexRoute,
  PrivateHomeProjectProject_idSettingsRouteRoute:
    PrivateHomeProjectProject_idSettingsRouteRouteWithChildren,
}

const PrivateHomeRouteWithChildren = PrivateHomeRoute._addFileChildren(
  PrivateHomeRouteChildren,
)

interface PrivateRouteChildren {
  PrivateHomeRoute: typeof PrivateHomeRouteWithChildren
  PrivateSignupRoute: typeof PrivateSignupRoute
  PrivateSubscriptionPendingRoute: typeof PrivateSubscriptionPendingRoute
  PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute: typeof PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateHomeRoute: PrivateHomeRouteWithChildren,
  PrivateSignupRoute: PrivateSignupRoute,
  PrivateSubscriptionPendingRoute: PrivateSubscriptionPendingRoute,
  PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute:
    PrivateCourseExportsCourse_version_guidVersionsVersion_guidPreviewRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PrivateRoute: PrivateRouteWithChildren,
  VerifiedRoute: VerifiedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
